import React, { Suspense, lazy } from 'react';
import ReactRender from '../tools/react-render';

const clientReviewsTarget = document.querySelector('[data-behaviour="react-client-reviews"]');
if (clientReviewsTarget) {
    const ClientReviews = lazy(() => import('./ClientReviews'));
    const ClientReviewsApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <ClientReviews filterHeader={clientReviewsTarget?.innerHTML} />
        </Suspense>
    );
    ReactRender(
        <ClientReviewsApp />,
        clientReviewsTarget,
    );
}

const searchTarget = document.querySelector('[data-behaviour="react-search"]');
if (searchTarget) {
    const searchQuery = searchTarget.dataset.query;
    const Search = lazy(() => import('./Search'));
    const SearchApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <Search searchQuery={searchQuery} />
        </Suspense>
    );
    ReactRender(<SearchApp />, searchTarget);
}

const bookingTarget = document.querySelector('[data-behaviour="react-booking"]');
if (bookingTarget) {
    const Booking = lazy(() => import('./Booking'));
    const BookingApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <Booking />
        </Suspense>
    );
    ReactRender(<BookingApp />, bookingTarget);
}

const faqsTarget = document.querySelector('[data-behaviour="react-filter-faqs"]');
if (faqsTarget) {
    const faqsTitle = 'title' in faqsTarget.dataset
        ? faqsTarget.dataset.title
        : false;
    const FAQs = lazy(() => import('./FAQs'));
    const FAQsApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <FAQs title={faqsTitle} />
        </Suspense>
    );
    ReactRender(<FAQsApp />, faqsTarget);
}

const findACentreTarget = document.querySelector(
    '[data-behaviour="google-map"][data-map-type="find-a-centre"]'
);
if (findACentreTarget) {
    const noResultsTitle = findACentreTarget.getAttribute('data-no-results-title');
    const noResultsText = findACentreTarget.getAttribute('data-no-results-text');
    const noResultsServicesText = findACentreTarget.getAttribute(
        'data-no-results-services-text',
    );
    const multiSiteId =
        parseInt(findACentreTarget.getAttribute('data-multi-site-id')) ?? 1;
    const FindACentreMap = lazy(() => import('./Maps').then((module) => ({default: module.FindACentreMap})));
    const FindACentreMapApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <FindACentreMap
                noResultsTitle={noResultsTitle}
                noResultsText={noResultsText}
                noResultsServicesText={noResultsServicesText}
                multiSiteId={multiSiteId}
            />
        </Suspense>
    );
    ReactRender(
        <FindACentreMapApp />,
        findACentreTarget,
    );
}

const locationMapTarget = document.querySelector(
    '[data-behaviour="google-map"][data-map-type="single-location-map"]'
);
if (locationMapTarget) {
    const geopoint = {
        lat: parseFloat(locationMapTarget.dataset.lat),
        lng: parseFloat(locationMapTarget.dataset.lng),
    };
    const LocationMap = lazy(() => import('./Maps').then((module) => ({default: module.LocationMap})));
    const LocationMapApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <LocationMap geopoint={geopoint} />
        </Suspense>
    );
    ReactRender(<LocationMapApp />, locationMapTarget);
}

const clientVideoReviewsTarget = document.querySelector(
    '[data-behaviour="react-client-video-reviews"]'
);
if (clientVideoReviewsTarget) {
    const VideoReviews = lazy(() => import('./ClientReviews/VideoReviews'));
    const VideoReviewsApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <VideoReviews filterHeader={clientVideoReviewsTarget?.innerHTML} />
        </Suspense>
    );
    ReactRender(
        <VideoReviewsApp />,
        clientVideoReviewsTarget,
    );
}

const seminarListingTargets = document.querySelectorAll('[data-behaviour="seminar-listing"]');
if (seminarListingTargets) {
    const SeminarListing = lazy(() => import('./SeminarListing'));

    seminarListingTargets.forEach(target => {
        const addictions = JSON.parse(target.dataset.seminarAddictions);
        const type = target.dataset.seminarType;
        const locations = JSON.parse(target.dataset.seminarLocations);
        const couponCode = 'couponCode' in target.dataset ? target.dataset.couponCode : '';
        const priceOverride = 'priceOverride' in target.dataset ? target.dataset.priceOverride : '';
        const overrideText = 'overrideText' in target.dataset ? target.dataset.overrideText : '';
        const overrideOriginalText = 'overrideOriginalText' in target.dataset ? target.dataset.overrideOriginalText : '';
        const form = 'form' in target.dataset ? target.dataset.form : '';

        const SeminarListingWrapper = () => (
            <>
                <Suspense fallback={<div>Loading...</div>}>
                    <SeminarListing
                        seminarAddictions={addictions}
                        seminarType={type}
                        seminarLocations={locations}
                        couponCode={couponCode}
                        priceOverride={priceOverride}
                        overrideText={overrideText}
                        overrideOriginalText={overrideOriginalText}
                        form={form}
                    />
                </Suspense>
            </>
        );

        ReactRender(<SeminarListingWrapper />, target);
    });
}
